module.exports = __webpack_public_path__ + "static/img/中国铁通@2x.501a8af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partners/中国铁通@2x.png
// module id = eNf6
// module chunks = 1